import React, { useMemo } from "react";
import { Card, Col, Row } from "reactstrap";
import { getUserRole } from "../../Components/utils/getUserRole";
import { Link } from "react-router-dom";
import FaqImg from "../../assets/images/faq-img.png";
import { getUsersList } from "../../helpers/fakebackend_helper";


const Section = ({ user }) => {
  console.log(user)  
  const fetchUsers = async () => {

    try {
      const response = await getUsersList();
      response.users.forEach((user) => {
      console.log(user?.userType);
    });
    } catch (error) {
      console.error("Error:", error);

      if (error.response) {
        console.log("Status:", error.response.status);
        console.log("Data:", error.response.data);
      }
    }
};

fetchUsers();
  const {role,userType} = useMemo(() => getUserRole(user), [user]);

  return (
    <Row className="mb-4">
      <Col xs="12">
        <Card className="rounded-0 bg-success-subtle mx-n4 mt-n4 border-top">
          <div className="px-3 px-md-4 py-2">
            <Row className="align-items-center">
              {/* TEXT SECTION */}
              <Col
                xs="12"
                lg="7"
                xxl="5"
                className="mb-4 mb-lg-0"
              >
                <h3 className="fs-24 lh-base mb-1">
                  Hi,{" "}
                  <span className="text-success">
                    {user?.name} 👋
                  </span>
                </h3>

                <p className="mb-3 text-muted">
                  Here’s what’s happening with your panel today.
                </p>

                <div className="d-flex flex-column flex-sm-row gap-2 gap-sm-3">
                  {console.log(role)}
                    {(user?.userType === "ADMIN"|| user?.role === "Admin") &&(
                      <Link to="/manage-user" className="btn btn-secondary">
                    Users
                  </Link>
                    )}
                    
                </div>
              </Col>

              {/* IMAGE SECTION */}
              <Col
                xs="12"
                lg="5"
                xxl="3"
                className="ms-auto d-none d-lg-block text-end"
              >
                <div className="faq-img">
                  <img
                    src={FaqImg}
                    alt="FAQ Illustration"
                    className="img-fluid"
                    style={{ maxHeight: "220px" }}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default Section;